module.exports = __webpack_public_path__ + "img/dyw_map.09bae954.png";